import React from 'react';
import { useIntl } from 'react-intl';
import TrustpilotStars from '@whitelabel/media/images/trustpilot-4-and-half-stars.svg';
import TrustpilotLogo from '@whitelabel/media/images/trustpilot-logo.svg';
import messages from './messages';
import { StyledTrustpilotBlock } from './styledTrustPilot';

export interface ITrustPilotProps {
  trustpilotCounter: string;
  className?: string;
  size?: 'sm' | 'lg';
}

const TrustPilot = ({ trustpilotCounter, className, size }: ITrustPilotProps): JSX.Element => {
  const { formatMessage, locale } = useIntl();
  const totalReviews = `${new Intl.NumberFormat(locale).format(+trustpilotCounter.replace(/[,.]/g, ''))}+`;

  return (
    <StyledTrustpilotBlock className={`trust-pilot ${className}`} $size={size} data-test-id="trust-pilot">
      <div className="logo">
        <img src={TrustpilotLogo} alt={formatMessage(messages.logoAltText)} />
      </div>
      <div className="stars">
        <img src={TrustpilotStars} alt={formatMessage(messages.starsAltText)} />
      </div>
      <div className="reviews">
        <span>{formatMessage(messages.reviews, { totalReviews })}</span>
        <span className="separator">•</span>
        <span className="excellent">{formatMessage(messages.excellent)}</span>
      </div>
    </StyledTrustpilotBlock>
  );
};

export default TrustPilot;
